import { Box, Button, FormControl, FormControlLabel, FormHelperText, Grid, Paper, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../../app/store";
import configUrls from "../../../config/configUrls";
import errorFormat from "../../../utils/errorFormat";


import { ISprocessoPrazoDTO, ProcessoPrazoDTO } from "../../../types/processo/ProcessoSetoresDTO";

import { usePrazoProcessoMutation } from "./processoPrazoApiSlice";
import DateInput from "../../../components/formControls/DateInput";



export const ProcessoPrazoForm = () => {


    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const navigate = useNavigate();
    const [create, status] = usePrazoProcessoMutation();

    const [campoVisivel, setCampoVisivel] = useState('diasCorridos');


    // Hook para seleção do processo
    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
    useEffect(() => {
        if (!processoSelecionado) {
            alert("Nenhum processo foi previamente selecionado");
            navigate(configUrls.PROCESSO_LIST_RT); // Usando useNavigate para navegação
        }
    }, [processoSelecionado, navigate]);

    const [prazo, setPrazo] = useState<ProcessoPrazoDTO>(ISprocessoPrazoDTO);

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();



        if (!prazo.data && !prazo.prazo_dias && !prazo.prazo_dias_uteis) {
            enqueueSnackbar("Preencha o prazo!", { variant: "error" });
            return;
        }
        const parms: ProcessoPrazoDTO = {
            id: "",
            processoId: processoSelecionado ? processoSelecionado.id : "",
            data: prazo.data,
            prazo_dias: prazo.prazo_dias,
            prazo_dias_uteis: prazo.prazo_dias_uteis,

        }
        await create(parms);
    }

    useEffect(() => {

        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            navigate(-1);
            // setGrupo(ISgrupo);          

        }
    }, [status]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        setPrazo((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }))
        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };


    const handleData = (data: string) => {
        setPrazo((prev) => ({
            ...prev,
            data: data,
        }))
    };

    const handleOptional = (val: string) => {
        setCampoVisivel(val);
        if (val !== 'diasCorridos') {
            setPrazo((prev) => ({
                ...prev,
                prazo_dias: "",
            }))
        }
        if (val !== 'diasUteis') {
            setPrazo((prev) => ({
                ...prev,
                prazo_dias_uteis: "",
            }))
        }
        if (val !== 'dataCerta') {
            handleData("");
        }
    };



    return (

        <>


            <Paper>

                <Typography variant="h6" component="h1" sx={{ padding: 2 }}>
                    Definir prazo para o processo: {processoSelecionado?.numeroProcesso}

                </Typography>
                <Box mt={2} p={2}>

                    <form onSubmit={handleSubmit} method='POST'>
                        <Grid container spacing={2}>

                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        defaultValue="female"
                                        name="radio-buttons-group"
                                        value={campoVisivel}
                                        onChange={(val) => handleOptional(val.target.value)}
                                    >
                                        <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                                            <Box display="flex">

                                                <FormControlLabel
                                                    value="diasCorridos"
                                                    control={<Radio />}
                                                    label="Dias corridos" />

                                            </Box>
                                            {campoVisivel === 'diasCorridos' && (
                                                <Box display="flex" alignItems="center">
                                                    <FormControl fullWidth>
                                                        <TextField
                                                            required
                                                            label="Dias corridos:"
                                                            name="prazo_dias"
                                                            onChange={handleChange}
                                                            size="small"
                                                            inputProps={{ maxLength: 4 }}
                                                            value={prazo.prazo_dias}
                                                        />
                                                       
                                                    </FormControl>
                                                </Box>
                                            )}
                                        </Box>




                                        <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                                            <Box display="flex" alignItems="center">
                                                <FormControlLabel
                                                    value="diasUteis"
                                                    control={<Radio />}
                                                    label="Dias sem finais de semana" />

                                            </Box>
                                            {campoVisivel === 'diasUteis' && (
                                                <Box display="flex" alignItems="center" >
                                                    <FormControl  fullWidth >
                                                        <TextField
                                                            required
                                                            label="Dias sem finais de semana:"
                                                            name="prazo_dias_uteis"
                                                            onChange={handleChange}
                                                            size="small"
                                                            inputProps={{ maxLength: 4 }}
                                                            value={prazo.prazo_dias_uteis}
                                                        />
                                                         
                                                      
                                                    </FormControl>
                                                </Box>
                                            )}
                                        </Box>


                                        <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
                                            <Box display="flex">
                                                <FormControlLabel
                                                    value="dataCerta"
                                                    control={<Radio />}
                                                    label="Data de certa" />
                                            </Box>
                                            {campoVisivel === 'dataCerta' && (
                                                <Box display="flex" alignItems="center">
                                                    
                                                        <DateInput
                                                            required
                                                            label="Data certa"
                                                            onChange={handleData} />
                                                    
                                                </Box>
                                            )}
                                        </Box>
                                    </RadioGroup>
                                </FormControl>
                            </Grid>


                            <Grid item xs={12}>
                                <Box display="flex" gap={2}>

                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="secondary"
                                    >
                                        Gravar
                                    </Button>

                                    <Button
                                        variant="contained"
                                        onClick={() => navigate(-1)}
                                    >
                                        Voltar
                                    </Button>
                                </Box>
                            </Grid>

                        </Grid>
                    </form>



                </Box>




            </Paper >










        </>







    );










};
